import React from "react";
import { Box } from "@mui/material";
import SalesforceConfigDataTable from "../components/salesforce-config/SalesforceConfigDataTable";

import apiConfig from "../config/appConfig";

const SalesforceConfigs = () => {
  const apiUrl = apiConfig.endpoints.salesforceConfig.paginated; // Replace with your backend API endpoint

  return (
    <Box sx={{ width: "100%", height: "100%" }}>
      <SalesforceConfigDataTable apiUrl={apiUrl} />
    </Box>
  );
};

export default SalesforceConfigs;
